// DO NOT EDIT -- generated from fs/api/vars/vars.proto

import * as protobuf from '../../../google/protobuf';

export enum Scope {
  INVALID_SCOPE = 0,
  user = 1,
  evt = 3,
  page = 4,
  document = 5,
  elem = 6,
  fsevt = 7
}

export enum Type {
  INVALID_TYPE = 0,
  bool = 1,
  date = 2,
  int = 3,
  real = 4,
  str = 5,
  bools = 6,
  dates = 7,
  ints = 8,
  reals = 9,
  strs = 10
}

export interface Var {
  /** user or evt */
  scope: Scope;
  /** base name, e.g. 'pricingPlan' rather than 'pricingPlan_str' or 'user_pricingPlan_str' */
  name: string;
  /** when this value was set */
  when: protobuf.timestamp | null;
  /** if true, this is a system field like `email`, omit type suffix when generating the full name */
  isSystem: boolean;
  bool?: boolean;
  date?: protobuf.timestamp | null;
  int?: protobuf.int64;
  real?: number;
  str?: string;
  bools?: BoolArray | null;
  dates?: DateArray | null;
  ints?: IntArray | null;
  reals?: RealArray | null;
  strs?: StrArray | null;
}

export namespace Var {
  /** the value, whose oneof must match `type` */
  export enum val {
    bool = 51,
    date = 52,
    int = 53,
    real = 54,
    str = 55,
    bools = 56,
    dates = 57,
    ints = 58,
    reals = 59,
    strs = 60
  }

  /** the value, whose oneof must match `type` */
  export function val_oneof(m: Var): { opt: val.bool, val: boolean } | { opt: val.bools, val: BoolArray } | { opt: val.date, val: protobuf.timestamp } | { opt: val.dates, val: DateArray } | { opt: val.int, val: protobuf.int64 } | { opt: val.ints, val: IntArray } | { opt: val.real, val: number } | { opt: val.reals, val: RealArray } | { opt: val.str, val: string } | { opt: val.strs, val: StrArray } | null {
    if (m.bool != null) { return { opt: val.bool, val: m.bool } }
    if (m.date != null) { return { opt: val.date, val: m.date } }
    if (m.int != null) { return { opt: val.int, val: m.int } }
    if (m.real != null) { return { opt: val.real, val: m.real } }
    if (m.str != null) { return { opt: val.str, val: m.str } }
    if (m.bools != null) { return { opt: val.bools, val: m.bools } }
    if (m.dates != null) { return { opt: val.dates, val: m.dates } }
    if (m.ints != null) { return { opt: val.ints, val: m.ints } }
    if (m.reals != null) { return { opt: val.reals, val: m.reals } }
    if (m.strs != null) { return { opt: val.strs, val: m.strs } }
    return null;
  }
}

export interface BoolArray {
  elements: boolean[];
}

export interface DateArray {
  elements: protobuf.timestamp[];
}

export interface IntArray {
  elements: protobuf.int64[];
}

export interface RealArray {
  elements: number[];
}

export interface StrArray {
  elements: string[];
}

/** The identity of a specific var. Must be interpreted in the context of some scope. */
export interface UnscopedVarId {
  name: string;
  type: Type;
}
